// src/components/VideoBackground.jsx
import React from 'react';
import backgroundVideo from '../assets/videos/background.mp4';

const VideoBackground = () => {
  return (
    <div className="video-container">
      <video autoPlay loop muted playsInline className="video-background">
        <source src={backgroundVideo} type="video/mp4" />
      </video>
      <div className="video-overlay"></div>
    </div>
  );
};

export default VideoBackground;